export default __webpack_public_path__ + "static/media/8_4_1.c2e8afc4.png";